const multipleData = {
  '法律': {
    // 'active': true,
    // '法律': [
    //   {
    //     name: '已作废',
    //     id: '已作废',
    //     type: 'state'
    //   },
    //   {
    //     name: '现行有效',
    //     id: '现行有效',
    //     type: 'state'
    //   }
    // ]
  },
  '法规': {
    // '状态': [
    //   {
    //     name: '已作废',
    //     id: '已作废',
    //     type: 'state'
    //   },
    //   {
    //     name: '现行有效',
    //     id: '现行有效',
    //     type: 'state'
    //   }
    // ]
  }
  //   '计量标准': {
  //     '认证类别': [
  //       {
  //         id: '1',
  //         name: '管理体系认证'
  //       },
  //       {
  //         id: '2',
  //         name: '服务认证'
  //       },
  //       {
  //         id: '3',
  //         name: '产品认证'
  //       }
  //     ],
  //     '认证领域': [
  //       {
  //         id: '1',
  //         name: '质量管理体系认证'
  //       },
  //       {
  //         id: '2',
  //         name: '环境管理体系认证'
  //       },
  //       {
  //         id: '3',
  //         name: '职业健康安全管理体系认证'
  //       }
  //     ],
  //     '行政区划': [
  //       {
  //         id: '1',
  //         name: '北京市'
  //       },
  //       {
  //         id: '2',
  //         name: '上海市'
  //       },
  //       {
  //         id: '3',
  //         name: '浙江省'
  //       }
  //     ]
  //   },
  //   '计量标准申请变更': {
  //     '认证类别': [
  //       {
  //         id: '1',
  //         name: '管理体系认证'
  //       },
  //       {
  //         id: '2',
  //         name: '服务认证'
  //       },
  //       {
  //         id: '3',
  //         name: '产品认证'
  //       }
  //     ],
  //     '认证领域': [
  //       {
  //         id: '1',
  //         name: '质量管理体系认证'
  //       },
  //       {
  //         id: '2',
  //         name: '环境管理体系认证'
  //       },
  //       {
  //         id: '3',
  //         name: '职业健康安全管理体系认证'
  //       }
  //     ],
  //     '行政区划': [
  //       {
  //         id: '1',
  //         name: '北京市'
  //       },
  //       {
  //         id: '2',
  //         name: '上海市'
  //       },
  //       {
  //         id: '3',
  //         name: '浙江省'
  //       },
  //       {
  //         id: '4',
  //         name: '辽宁省'
  //       }
  //     ]
  //   }
}
export default multipleData



// WEBPACK FOOTER //
// ./src/layout/common/config/law.js